import styled from 'styled-components'

export const Anchor = styled.a<{ disabled?: boolean; nonFocusable?: boolean }>`
  display: inline-flex;
  align-items: center;
  border: none;
  border-bottom: 1px solid transparent;
  cursor: default;

  ${({ nonFocusable }) => nonFocusable && 'border-bottom: 4px solid #303032;'}

  ${({ disabled }) => {
    if (disabled) {
      return `
        border-bottom-style: dashed;
        border-bottom-color: #006BFF;
        cursor: not-allowed;
      `
    } else {
      return `
        cursor: pointer;

        &:hover {
          border-bottom-color: #006BFF;
        }

        &:focus {
          outline: none;
          border-bottom-width: 2px;
          border-bottom-color: #ABBED1;
        }
      `
    }
  }}
`
